import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
	.page-wrapper-header-title--icon {
		& path {
			fill: ${tokens.color_gray_dark};
		}
	}
`;

export const Footer = styled.footer`
	display: flex;
	justify-content: flex-end;
	margin: 20px;
`;
